import { useEffect, useState, useCallback } from "react";
import useAuth from "../context/AuthProvider";
import React from "react";
import { ReconciliationTransactionReportModel_Resp, ReconciliationTransactionReportModel } from "../models/TaxTransactionReportModel";
import { Box } from "@mui/system";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, LinearProgress, MenuItem, Select, SelectChangeEvent, SelectProps, Tab, Tabs, TextField, Typography } from "@mui/material";
import { ReconciliationList } from "../components/Lists/ReconciliationList";
import { writeXlsxFile, formatUtcToLocal, mstDateStringToUtcIsoString } from "../helper/utils";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Search, Close, FileDownload, Refresh } from "@mui/icons-material";
import { Autocomplete } from "@mui/material";
import formatPrice from "../helper/currencyFormatter";
import Swal from "sweetalert2";
import { Form, Formik } from "formik";
import { FMTextField } from "../components/Elements/input";
import moment from "moment";
import { MenuDropdown } from "../components/Elements/MenuDropdown";
import FilerNotes from "../components/Elements/filerNotes";
import { getPolicyFilingAndReport, NewCompletedFilingsModel } from "../models/NewCompletedFilingsModel";
import { apiClient } from "../helper/api";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useParams } from "react-router-dom";

export enum ReconTabs {
    Open = 1,
    Closed = 2,
    Removed = 3
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            sx={{
                height: "100%",
            }}
            {...other}
        >
            {value === index && (
                <Box
                    sx={{
                        height: "100%",
                    }}
                >
                    {children}
                </Box>
            )}
        </Box>
    );
}

export const ReconciliationQueue = () => {
    const { user } = useAuth();
    const token = user?.token;
    const params = useParams();
    const [loading, setLoading] = useState(false);
    const [reportModuleCL, setReportModuleCL] = useState<ReconciliationTransactionReportModel_Resp>({ getData_Resp: [], totalCount: 0 });
    const [selectedTab, setSelectedTab] = useState(0);
    const [selectedRows, setSelectedRows] = useState<ReconciliationTransactionReportModel[] | null>([]);
    const [_pageSize, setPageSize] = useState(50);
    const [_currentPage, setCurrentPage] = useState(1);
    const stateData = React.useRef(0);
    const customerData = React.useRef(0);
    const taxData = React.useRef("");
    const statusData = React.useRef("");
    const policyNumberData = React.useRef("");
    const [openNotesDialog, setOpenNotesDialog] = useState<string>('');
    const [filterModel, setFilterModel] = useState<{ items: { columnField: string, value: string, operatorValue: string }[], logicOperator?: 'and' | 'or' }>({ items: [], logicOperator: 'and' });
    const [sortModel, setSortModel] = useState<{ field: string, sort: string }[]>([]);
    const [tax, setTax] = useState("");
    const [status, setstatus] = useState<string[]>([
        'Not Started', 'Waiting on Client', 'Ready to File', 'Filed',
        // Note: Disabled intentionally until the workflows are ready.
        // 'Pending Autofile'
    ]);
    const [selectedCustomer, setSelectedCustomer] = useState(0);
    const [selectedPolicyNumber, setSelectedPolicyNumber] = useState("");
    const [selectedState, setSelectedState] = useState(0);
    const [selectedStatus, setSelectedStatus] = useState<string>('');
    const [TaxandFees, setTaxandFees] = useState<string[]>([""]);
    const [currentPolicySubStatus, setCurrentPolicySubStatus] = useState<string>('');

    const handleFilterModelChange = useCallback((newFilterModel: { items: { columnField: string, value: string, operatorValue: string }[], logicOperator?: 'and' | 'or' }) => {
        setFilterModel(newFilterModel);
    }, []);

    const handleSortModelChange = useCallback((newSortModel: { field: string, sort: string }[]) => {
        setSortModel(newSortModel);
    }, []);

    const handleSubmitNotes = (data: {
        status: string,
        noteType: string,
        noteDetail: string,
        noteUser: string,
        firstRequestDate: string,
        secondRequestDate: string,
        thirdRequestDate: string,
        suspendedDate: string,
        noteDate?: string | undefined,
        policySubStatus: string,
        dateDeclarationFiled: string
    }) => {
        const { firstRequestDate, secondRequestDate, thirdRequestDate, suspendedDate, noteType, noteDetail, noteUser, noteDate, status, policySubStatus, dateDeclarationFiled } = data;
        setOpenNotesDialog('');
        updateAllStatus(status, selectedRows, noteDetail, noteUser, firstRequestDate, secondRequestDate, thirdRequestDate, suspendedDate, noteDate, policySubStatus, dateDeclarationFiled);
    };
    
    const handleOpenNotesDialog = (status: string) => {
        setOpenNotesDialog(status);
    };

    const isDueDateWithinRange = (dueDateStr: string): boolean => {
        const currentDate = new Date();
        const dueDate = parseDueDate(dueDateStr);
        const dateDifference = dueDate.getTime() - currentDate.getTime();
        const dayDifference = dateDifference / (1000 * 3600 * 24);
        return dayDifference >= 0 && dayDifference <= 9;
    };

    const parseDueDate = (dueDateStr: string): Date => {
        const currentDate = new Date();
        const [month, day] = dueDateStr.split('-').map(Number);
        const year = currentDate.getFullYear();
        return new Date(year, month - 1, day);
    };

    const handleCloseNotesDialog = () => {
        setOpenNotesDialog('');
    };

    useEffect(() => {
        let value: ReconTabs = ReconTabs.Open;
        if(params.LastTabId === 'RemovedQueue') {
            value = ReconTabs.Removed;
        }
        setSelectedTab(value);
        setReportModuleCL({ getData_Resp: [], totalCount: 0 });
        fetchStateData();
        fetchCustomer();
        fetchTaxFeeName();
    }, []);

    useEffect(() => {
        stateData.current = 0;
        customerData.current = 0;
        taxData.current = "";
        statusData.current = "";
        policyNumberData.current = "";
        setSelectedPolicyNumber("");
        setSelectedCustomer(0);
        setSelectedState(0);
        setSelectedStatus("");
        setFilterModel({ items: [], logicOperator: 'and' });
        setSortModel([]);
        setSelectedRows([]);
    }, [selectedTab]);

    useEffect(() => {
        const fetchData = async () => {
            await fetchMainData();
        };
        if(selectedTab !== 0) {
            fetchData();
        }
    }, [_pageSize, _currentPage, filterModel, sortModel]);

    const fetchMainData = async () => {
        setLoading(true);
        try {
            const response = await fetchReconciliationData(_pageSize, _currentPage);
            if (response.resp === 0) {
                setReportModuleCL(response.data);
            }else{
                setReportModuleCL({ getData_Resp: [], totalCount: 0 });
            }
        } catch (error) {
            setReportModuleCL({ getData_Resp: [], totalCount: 0 });
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchReconciliationData = async (pageSize: number, pageNumber: number) => {
        const requestBody = {
            userId: user?.userId || 0,
            customerId: customerData.current || 0,
            taxName: taxData.current || "",
            stateId: stateData.current || 0,
            status: statusData.current || "",
            policyNumber: policyNumberData.current || "",
            customerPolicyIds: pageSize === reportModuleCL.totalCount ? selectedRows?.map(m => m.customerPolicyId).join(',') || "" : "",
            pageNumber: pageNumber,
            pageSize: pageSize,
            field: sortModel?.[0]?.['field'] || '',
            sort: sortModel?.[0]?.['sort'] || '',
            filterModel: filterModel,
            tabName: selectedTab === ReconTabs.Open ? "Open" : selectedTab === ReconTabs.Closed ? "Closed" : "Removed"
        };

        return apiClient(`/ReconQueue/getReconQueueData`, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
            body: JSON.stringify(requestBody)
        });
    };
    
    function updateStatus(status: string, selectedRow: any) {
        setLoading(true);
        const noteDate = formatUtcToLocal(new Date().toISOString(), "MM/DD/YYYY");
        apiClient(`/PolicyDashBoard/updateCustomerPolicyStatus?status=${status}&&filerName=${user?.userFirstName + ' ' + user?.userlastName}&&filerDate=${encodeURIComponent(mstDateStringToUtcIsoString(noteDate))}`, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
            body: JSON.stringify(selectedRow)
        }, {
            message: `Update the Customer Policy status to '${status}'.`
        }).then((res) => {
            if (!res) return
            setLoading(false);
            if (res !== null && res !== undefined) {
                Swal.fire({
                    title: res.data,
                    text: res.message,
                    iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                    confirmButtonColor: '#02A4E3',
                    confirmButtonText: 'OK',
                    customClass: {
                        confirmButton: 'btn-radius',
                        cancelButton: 'btn-radius',
                        popup: 'card-radius'
                    }
                }).then((result) => {
                    window.location.reload();
                })
            }
        }).finally(() => {
            setLoading(false);
        });
    }
    
    var count = 0;
    function updateAllStatus(status: string, selectedRow: any, notes: string = '', filerName: string = '', firstRequestDate: string = '', secondRequestDate: string = '', thirdRequestDate: string = '', suspendedDate: string = '', noteDate?: string, policySubStatus: string = '', dateDeclarationFiled: string = '') {
        setLoading(true);
        if (noteDate === null || noteDate === '' || noteDate === undefined) {
            noteDate = formatUtcToLocal(new Date().toISOString(), "MM/DD/YYYY");
        }
        if (status === "Filed") {
            var customerPolicyIds = selectedRows?.map(m => m.customerPolicyId ?? 0) ?? [];
            if (count === 0) {

                (async () => {
                    try {
                        const response = await getTaxTypeData('getIsPolicyFilingAndReportByCustPolIds', customerPolicyIds);

                        if (response != null && response.length > 0) {
                            const dueDateNotValid: ReconciliationTransactionReportModel[] = []; // where due date is not prior 10 days of due date
                            response.forEach((e: getPolicyFilingAndReport) => {
                                if (e.report == true) {
                                    var newData = selectedRows?.find(m => m.customerPolicyId == e.customerPolicyId);
                                    if (!isDueDateWithinRange(newData?.dueDate) && newData !== undefined) {
                                        dueDateNotValid.push(newData);
                                    }
                                }
                            });

                            const DueDateNotValid = new Set(dueDateNotValid.map(item => item.customerPolicyId));
                            const filteredSelectedIds = selectedRows?.filter(item => !DueDateNotValid.has(item.customerPolicyId!))
                            console.log("filteredSelectedIds :", filteredSelectedIds);
                            count++;
                        }
                        setLoading(false);
                        return;
                    } catch (error) {
                        console.error("Error fetching tax type data:", error);
                        return;
                    }
                })();
                return;
            }
        }

        apiClient(`/PolicyDashBoard/updateCustomerPolicyStatus?status=${status}&&notes=${notes}&&filerName=${user?.userFirstName + ' ' + user?.userlastName}&&filerDate=${encodeURIComponent(mstDateStringToUtcIsoString(noteDate))}&&firstRequestDate=${encodeURIComponent(mstDateStringToUtcIsoString(firstRequestDate))}&&secondRequestDate=${encodeURIComponent(mstDateStringToUtcIsoString(secondRequestDate))}&&thirdRequestDate=${encodeURIComponent(mstDateStringToUtcIsoString(thirdRequestDate))}&&suspendedDate=${encodeURIComponent(mstDateStringToUtcIsoString(suspendedDate))}&&policySubStatus=${policySubStatus}&&dateDeclarationFiled=${dateDeclarationFiled}`, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
            body: JSON.stringify(selectedRow)
        }, {
            message: `Update the Customer Policy status to '${status}'.`
        })
        .then((res) => {
            if (!res) return
            if (res !== null && res !== undefined) {
                Swal.fire({
                    title: res.data,
                    text: res.message,
                    iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                    confirmButtonColor: '#02A4E3',
                    confirmButtonText: 'OK',
                    customClass: {
                        confirmButton: 'btn-radius',
                        cancelButton: 'btn-radius',
                        popup: 'card-radius'
                    }
                })
                .then((result) => {
                    setSelectedRows([]);
                    fetchReconciliationData(_pageSize, _currentPage)
                })
            }
        })
        .finally(() => {
            setLoading(false);
        })
    }

    const getTaxTypeData = async (action: string, customerPolicyIds: number[]) => {
        const initValueExport = {
            customerPolicyIds: customerPolicyIds,
            option: ''
        };

        const res = await apiClient(`/PolicyDashBoard/${action}`,
            {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }),
                body: JSON.stringify(initValueExport)
            }
        );

        if (res?.data != null) {
            return res.data;
        } else {
            throw new Error("Response data is null");
        }
    };

    const onExportXlsx = (values: ReconciliationTransactionReportModel[]) => {
        setLoading(true);
        if (values?.length === 0) {
            setLoading(false);
            return;
        }
        const fieldsToExport: (keyof ReconciliationTransactionReportModel)[] = [
            'invoiceNumber', 'insuredName', 'policyNumber',
            'homeState', 'taxType', 'transactionType', 'invDate',
            'policyEffDate', 'policyExpDate', 'grossPremium', 'taxableFees', 'taxAmt', 'client', 'clientDiv'
        ];
        const capitalizeFirstLetter = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

        const formattedValues = values.map(item => {
            const cleanAndFormatValue = (value: string | null | undefined): string => {
                if (value == null || value === '') return "";
            
                let cleanedValue = value.replace(/[,\$]/g, "").trim();
            
                // If the value is in parentheses, treat it as negative
                if (cleanedValue.startsWith("(") && cleanedValue.endsWith(")")) {
                    cleanedValue = "-" + cleanedValue.slice(1, -1);  // Remove parentheses and add negative sign
                }
            
                // Convert to a number and format if valid
                const numericValue = parseFloat(cleanedValue);
                return isNaN(numericValue) ? value : `${formatPrice(numericValue.toString())}`;
            };
        
            // Apply formatting for currency fields
            item.taxAmt = cleanAndFormatValue(item.taxAmt);
            item.grossPremium = cleanAndFormatValue(item.grossPremium);
            item.taxableFees = cleanAndFormatValue(item.taxableFees);
        
            // Format dates if they are not null or empty
            const invDate = item.invDate && item.invDate !== '1900-01-01T00:00:00' ? new Date(item.invDate) : "";
            const policyEffDate = item.policyEffDate && item.policyEffDate !== '1900-01-01T00:00:00' ? new Date(item.policyEffDate) : "";
            const policyExpDate = item.policyExpDate && item.policyExpDate !== '1900-01-01T00:00:00' ? new Date(item.policyExpDate) : "";
            const dateFiled = item.dateFiled && item.dateFiled !== '1900-01-01T00:00:00' ? new Date(item.dateFiled) : "";
        
            const update: (string | number | Date | undefined)[] = fieldsToExport.map((key: keyof ReconciliationTransactionReportModel) => {
                if (key === 'invDate') return invDate;
                if (key === 'policyEffDate') return policyEffDate;
                if (key === 'policyExpDate') return policyExpDate;
                if (key === 'dateFiled') return dateFiled;
                return item[key];
            });
        
            return update;
        });

        const headers = fieldsToExport.map(field => capitalizeFirstLetter(field));

        const updates = [
            headers,
            ...formattedValues
        ];
        writeXlsxFile(updates, "ReconciliationQueue");
        setLoading(false);
    };

    const handleExportXlsxNew = async () => {
        try {
            setLoading(true);
            const response = await fetchReconciliationData(reportModuleCL.totalCount, 1);
            if (!response) return;
            if (response.resp === 0) {
                const val = response.data.getData_Resp;
                if (!val || val.length === 0) return;
                onExportXlsx(val);
            }
        } catch (error) {
            console.error("Error occurred:", error);
        }
        setLoading(false);
    };

    const fetchTaxFeeName = () => {
        apiClient(`/PolicyFilingType/GetAllTaxandFeeName`, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        }).then((responseJson) => {
            if (!responseJson) return
            if (responseJson.data != null) {
                setTaxandFees(responseJson.data.map((item: any) => item.policyFilingTypeName));
            }
        })
    };

    const FMSelectTaxAndFeesCustom: React.FC<SelectProps> = ({
        variant,
        ...props
    }) => {
        const handleTaxChange = (event: SelectChangeEvent<string>) => {
            const selectedTax = event.target.value;
            setLoading(true);
            setTax(selectedTax);
            taxData.current = selectedTax;
            setLoading(false);
        };

        return (
            <div>
                <FormControl fullWidth>
                    <Select
                        onChange={handleTaxChange}
                        value={tax}
                        id="test-select-label"
                        autoWidth
                        size="small"
                        label={null}
                        className="border-round custom-menu-item"
                        IconComponent={ExpandMoreIcon}
                        displayEmpty
                    >
                        <MenuItem key={""} value={""} className="custom-menu-item">
                            Tax Type
                        </MenuItem>
                        {TaxandFees?.map((taxdata) => (
                            <MenuItem
                                key={taxdata || ''}
                                className="custom-menu-item"
                                value={taxdata}
                            >
                                {taxdata}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
        );
    };

    const statusList = [
        'Not Started',
        'Waiting on Client',
        'Ready to File',
        'Filed',
        // Note: Disabled intentionally until the workflows are ready.
        // 'Pending Autofile',
        'Removed',
        'Filed - Binder'
    ];
    const isRowSelected = selectedRows !== null && selectedRows?.length > 0

    const FMSelectStatus: React.FC<SelectProps> = ({
        variant,
        ...props
    }) => {
        const handleStatusChange = (event: SelectChangeEvent<string>) => {
            const newStatus = event.target.value;
            setLoading(true);
            setSelectedStatus(newStatus);
            statusData.current = newStatus;
            setLoading(false);
        };

        return (
            <div>
                <FormControl fullWidth>
                    <Select
                        onChange={handleStatusChange}
                        value={selectedStatus}
                        id="status-select"
                        autoWidth
                        size="small"
                        label={null}
                        className="border-round custom-menu-item"
                        IconComponent={ExpandMoreIcon}
                        displayEmpty
                    >
                        <MenuItem key={""} value={""} className="custom-menu-item">
                            Status
                        </MenuItem>
                        {statusList.map((item, key) => (
                            <MenuItem
                                key={key}
                                className="custom-menu-item"
                                value={item}
                            >
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
        );
    };

    const initialUserdata = { partnersId: 0, customerName: "" };
    const [Customer, setCustomer] = useState([initialUserdata]);
    const fetchCustomer = () => {
        apiClient("/Partners/getPartners", {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        })
        .then((responseJson) => {
            if (!responseJson) return
            setCustomer(responseJson.data);
        })
    };

    const FMSelectCustomCustomer: React.FC<SelectProps> = ({
        variant,
        ...props
    }) => {
        const handleChange = (event: SelectChangeEvent) => {
            setLoading(true);
            customerData.current = Number(event.target.value);
            setSelectedCustomer(Number(event.target.value));
            setLoading(false);
        };

        return (
            <div>
                <FormControl fullWidth>
                    <Select
                        onChange={handleChange}
                        value={selectedCustomer.toString()}
                        id="test-select-label"
                        autoWidth
                        size="small"
                        label={null}
                        className="border-round custom-menu-item"
                        IconComponent={ExpandMoreIcon}
                        displayEmpty
                    >
                        <MenuItem key={0} value={0} className="custom-menu-item">
                            Client
                        </MenuItem>
                        {Customer?.map((item, key) => (
                            <MenuItem
                                key={key}
                                className="custom-menu-item"
                                value={item.partnersId}
                            >
                                {item.customerName}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
        );
    };

    const initialStatedata = { stateId: 0, stateName: "" };
    const [States, setStates] = useState([initialStatedata]);

    const [openPaidDialog, setOpenPaidDialog] = useState(false);
    const fetchStateData = () => {
        apiClient("/States/getStates", {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        })
        .then((responseJson) => {
            if (!responseJson) return
            setStates(responseJson.data);
        })
    };

    const FMSelectStateCustom: React.FC<SelectProps> = ({ variant, ...props }) => {
        const handleChangestate = (event: SelectChangeEvent) => {
            setLoading(true);
            stateData.current = Number(event.target.value);
            setSelectedState(Number(event.target.value));
            setLoading(false);
        };
        return (
            <FormControl fullWidth>
                <Select
                    onChange={handleChangestate}
                    value={selectedState.toString()}
                    size="small"
                    id="test-select-label"
                    label={null}
                    className="border-round custom-menu-item"
                    IconComponent={ExpandMoreIcon}
                    displayEmpty
                >
                    <MenuItem value={"0"} className="custom-menu-item">Home State</MenuItem>
                    {States?.map((state, key) => (
                        <MenuItem
                            key={key}
                            value={state.stateId}
                            className="custom-menu-item"
                        >
                            {state.stateName}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        );
    };

    function ClearSearch() {
        setLoading(true);
        stateData.current = 0;
        setSelectedState(0);
        customerData.current = 0;
        setSelectedCustomer(0);
        policyNumberData.current = "";
        setSelectedPolicyNumber("");
        taxData.current = "";
        statusData.current = "";
        setSelectedStatus("");
        setTax("");
        setLoading(false);
        fetchMainData();
    }

    const handleClosePaidDialog = () => {
        setOpenPaidDialog(false);
    };

    const handlePolicyNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedPolicyNumber(e.target.value);
        policyNumberData.current = encodeURIComponent(e.target.value);
      }
    interface newProp {
        handleClose: () => void;
        open: boolean;
    }

    interface StatusUpdateProp {
        paymentPeriod?: string;
        isPaid: boolean;
    }

    const ShowPaymentPeriod = ({ open, handleClose }: newProp) => {
        const initValuePaid: StatusUpdateProp = {
            isPaid: true,
            paymentPeriod: '',
        }

        return (
            <Dialog open={open} onClose={handleClose} maxWidth={'lg'}>
                <DialogTitle className='card-title'>Payment Period</DialogTitle>
                <React.Fragment>
                    <Formik
                        initialValues={initValuePaid}
                        onSubmit={(data, setError) => {
                            updateStatusChange(data)
                        }}
                    >
                        {({ values, isSubmitting, setErrors }) => (
                            <Form className='main-form'>
                                <DialogContent>
                                    <Grid item xs={12}>
                                        <FormControl sx={{ width: '100%', minWidth: '500px' }}>
                                            <FMTextField
                                                name="paymentPeriod"
                                                label={null}
                                                type="text"
                                                fullWidth
                                                variant="outlined"
                                                sx={{ marginTop: 2 }}
                                                multiline
                                                required
                                            />
                                        </FormControl>
                                    </Grid>
                                </DialogContent>
                                <DialogActions>
                                    <button className='btn-2 btn d-flex btn-primary search-btn' style={{ minWidth: '125px' }} type='button' onClick={handleClose}>Cancel</button>
                                    <button className='btn btn-primary active-btn-blue' type='submit' disabled={isSubmitting}>Submit</button>
                                </DialogActions>
                            </Form>
                        )}
                    </Formik>
                </React.Fragment>
            </Dialog>
        );
    };

    function checkSelectedRowsForNY(): boolean {
        if (selectedRows?.find(x => x.homeState === 'NY')) {
            if (selectedRows.find(x => x.homeState !== 'NY')) {
                Swal.fire({
                    title: 'Warning!',
                    text: "Please select filings either specifically for New York or those that exclude New York, as there is a special rule for changing the status in New York.",
                    iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                    confirmButtonColor: '#02A4E3',
                    customClass: {
                        confirmButton: 'btn-radius',
                        popup: 'card-radius'
                    }
                })
                    .then((result) => {
                        return false;
                    });
                return false;
            }
            return true;
        }
        return true;
    }

    const getCustomerPolicyDetails = async (customerPolicyId: number): Promise<string> => {
        try {
            setLoading(true);
            const initCustValue = {
              customerPolicyId: customerPolicyId
            };
            const res = await apiClient(`/PolicyDashBoard/getPolicySubStatusByCustomerPolicyId`,
              {
                method: "POST",
                headers: new Headers({
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                }),
                body: JSON.stringify(initCustValue)
              }
            );
      
            if (res?.data !== null) {
              setLoading(false);
              return res.data;
            } else {
              setLoading(false);
              throw new Error("Response data is null");
            }
          } catch (error) {
            setLoading(false);
            throw error;
          }
      };

    function handleStatus(status: string) {
        if (!checkSelectedRowsForNY()) {
            return;
        }
        setCurrentPolicySubStatus('');
        const isNewYorkFiling = selectedRows && selectedRows?.length === 1 && selectedRows[0].homeState === 'NY' && (selectedRows[0].transactionTypeName === 'New Business' || selectedRows[0].transactionTypeName === 'Renewal Business')
        if (status === 'Waiting on Client' || (status === 'Filed' && isNewYorkFiling)) {
            (async () => {
                const customerPolicyId = selectedRows && selectedRows[0]?.customerPolicyId !== undefined
                ? selectedRows[0].customerPolicyId
                : 0;
                const response = await getCustomerPolicyDetails(customerPolicyId);
                setCurrentPolicySubStatus(response);
                handleOpenNotesDialog(status);
            })();
        }
        else if (selectedRows?.find(m => m.homeState === "NY") && selectedRows.length !== 1 && status === "Filed") {
            Swal.fire({
                title: "",
                text: "Please select one filing for 'New York' state",
                icon: 'warning',
                confirmButtonText: "OK",
            });
            return;
        }
        else {
            Swal.fire({
                title: 'Confirmation!',
                text: "Do you want to update customer policy's status as " + status + "?",
                iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
                showCancelButton: true,
                confirmButtonColor: '#02A4E3',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Proceed',
                customClass: {
                    confirmButton: 'btn-radius',
                    cancelButton: 'btn-radius',
                    popup: 'card-radius'
                }
            })
            .then((result) => {
                if (result.isConfirmed) {
                    setLoading(true);
                    if (status !== undefined && status !== '' && status !== null) {
                        setCurrentPolicySubStatus('');
                        updateStatus(status, selectedRows);
                        fetchReconciliationData(_pageSize, _currentPage);
                    }
                }
            });
        }
    }

    const updateStatusChange = ({isPaid, paymentPeriod}: StatusUpdateProp) => {
        apiClient(`/ReconQueue/updateReconPaidStatus`,
            {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }),
                body: JSON.stringify({
                    userId: user?.userId || 0,
                    selectedRows: selectedRows,
                    isPaid,
                    paymentPeriod,
                })
            },{
                message: `${isPaid ? "Set the Customer Policy to 'Paid'" : "Revert the Customer Policy to 'Unpaid."}`
            }
        ).then((res) => {
            if (!res) throw new Error('Failed to update')
            if (res.resp === 1) {
                Swal.fire({
                    title: res.message,
                    text: "",
                    icon: "warning",
                    confirmButtonText: "OK",
                });
            } else if (res.resp === 0) {
                Swal.fire({
                    title: "Data Successfully saved",
                    text: "",
                    icon: "success",
                    confirmButtonText: "OK",
                });
                setSelectedRows([]);
                handleClosePaidDialog();
                fetchMainData();
            } else {
                Swal.fire({
                    title: "Unexpected response",
                    text: "The response code was not recognized.",
                    icon: "warning",
                    confirmButtonText: "OK",
                });
            }
        }).catch((error) => {
            Swal.fire({
                title: "Error",
                text: error.message,
                icon: "error",
                confirmButtonText: "OK",
            });
        });
    }

    const handleStatusChange = () => {
        if (selectedTab !== ReconTabs.Closed) {
            setOpenPaidDialog(true);
            return
        }
        Swal.fire({
            title: 'Confirmation!',
            text: "Do you want to revert?",
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Proceed',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                updateStatusChange({
                    isPaid: false,
                    paymentPeriod: '',
                })
            }
        });
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            {/* <div className="d-flex align-items-center justify-content-between mb-2">
                <div className="card-title">
                    <span className="d-flex">{selectedTab === ReconTabs.Removed ? "Removed" : ""} Reconciliation Queue</span>
                </div>
            </div> */}
            
            <Box sx={{ width: "100%" }}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: 1.5,
                        px: 2,
                        py: 1.5,
                        borderBottom: "1px solid #e2e8f0",
                        backgroundColor: "#fafbfc",
                        minHeight: 56,
                        marginLeft: { xs: '-24px', md: '0px' },
                        marginRight: { xs: '-24px', md: '0px' },
                    }}
                >
                    {selectedTab === ReconTabs.Removed ? (
                        <h4 className="mb-0 py-2" style={{ fontWeight: 600, color: "#0f172a" }}>
                            Removed Reconciliation Queue
                        </h4>
                    ) : (
                        <>
                            {/* Tabs: desktop only (md and up) */}
                            <Tabs
                                value={selectedTab}
                                onChange={(event, newValue) => setSelectedTab(newValue)}
                                aria-label="Reconciliation Tabs"
                                sx={{
                                    // display: { xs: "none", md: "flex" },
                                    minHeight: 48,
                                    "& .MuiTab-root": { textTransform: "none", fontWeight: 600, fontSize: "0.9375rem" },
                                    "& .Mui-selected": { color: "#2099d2" },
                                    "& .MuiTabs-indicator": { backgroundColor: "#2099d2", height: 3, borderRadius: "3px 3px 0 0" },
                                }}
                            >
                                <Tab label="Open Payables" value={ReconTabs.Open} />
                                <Tab label="Closed Payables" value={ReconTabs.Closed} />
                            </Tabs>
                            {/* Select option for mobile/tablet view */}
                            {/* <FormControl
                                size="small"
                                sx={{
                                    display: { xs: "block", md: "none" },
                                    minWidth: 160,
                                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e2e8f0" },
                                    "& .MuiSelect-select": { fontWeight: 600, color: "#2099d2", py: 0.9 },
                                }}
                            >
                                <Select
                                    value={selectedTab}
                                    onChange={(e) => setSelectedTab(Number(e.target.value))}
                                    displayEmpty
                                    sx={{ textTransform: "none", fontSize: "0.9375rem" }}
                                >
                                    <MenuItem value={ReconTabs.Open}>Open Payables</MenuItem>
                                    <MenuItem value={ReconTabs.Closed}>Closed Payables</MenuItem>
                                </Select>
                            </FormControl> */}
                        </>
                    )}
                </Box>
                <Box
                    sx={{
                        width: "100%",
                        py: 2,
                        // px: 2,
                        // backgroundColor: "#ffffff",
                        // borderBottom: "1px solid #e2e8f0",
                    }}
                >
                    <Grid container spacing={2} className="filter-grid" display="flex">
                            <Grid item xl={2} lg={4} sm={6} xs={12}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        sx={{
                                            marginTop: "-4px !important",
                                            "& .MuiAutocomplete-input": {
                                                padding: "0px 4px 0px 5px !important",
                                            },
                                        }}
                                        options={Customer}
                                        getOptionLabel={(option) => option.customerName}
                                        onChange={(event, value) => {
                                            setSelectedCustomer(value?.partnersId ?? 0);
                                            customerData.current = value?.partnersId ?? 0;
                                        }}
                                        value={Customer.find(item => item.partnersId === selectedCustomer) ?? null}
                                        renderInput={(params) => (
                                            <TextField
                                                sx={{
                                                    ".MuiFormLabel-root.Mui-focused": {
                                                        color: (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0) ? "#000" : "#cccccc !important",
                                                    },
                                                    '& .MuiInputBase-root': { marginTop: '5px !important' },
                                                    '& .MuiOutlinedInput-root': { padding: '4.5px 9px' },
                                                    '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                                                    '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
                                                }}
                                                {...params}
                                                label="Client"
                                                InputLabelProps={{ ...params.InputLabelProps, shrink: (selectedCustomer > 0 || (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0)) ? true : false }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xl={2} lg={4} sm={6} xs={12}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        sx={{
                                            marginTop: "-4px !important",
                                            "& .MuiAutocomplete-input": {
                                                padding: "0px 4px 0px 5px !important",
                                            },
                                        }}
                                        options={States}
                                        getOptionLabel={(option) => option.stateName}
                                        onChange={(event, value) => {
                                            setSelectedState(value?.stateId ?? 0);
                                            stateData.current = value?.stateId ?? 0;
                                        }}
                                        value={States.find(item => item.stateId === selectedState) ?? null}
                                        renderInput={(params) => (
                                            <TextField
                                                sx={{
                                                    ".MuiFormLabel-root.Mui-focused": {
                                                        color: (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0) ? "#000" : "#cccccc !important",
                                                    },
                                                    '& .MuiInputBase-root': { marginTop: '5px !important' },
                                                    '& .MuiOutlinedInput-root': { padding: '4.5px 9px' },
                                                    '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                                                    '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
                                                }}
                                                {...params}
                                                label="Home State"
                                                InputLabelProps={{ ...params.InputLabelProps, shrink: (selectedState > 0 || (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0)) ? true : false }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xl={2} lg={4} sm={6} xs={12}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        sx={{
                                            marginTop: "-4px !important",
                                            "& .MuiAutocomplete-input": {
                                                padding: "0px 4px 0px 5px !important",
                                            },
                                        }}
                                        options={TaxandFees}
                                        getOptionLabel={(option) => option}
                                        onChange={(event, value) => {
                                            setTax(value ?? "");
                                            taxData.current = value ?? "";
                                        }}
                                        value={tax}
                                        renderInput={(params) => (
                                            <TextField
                                                sx={{
                                                    ".MuiFormLabel-root.Mui-focused": {
                                                        color: (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0) ? "#000" : "#cccccc !important",
                                                    },
                                                    '& .MuiInputBase-root': { marginTop: '5px !important' },
                                                    '& .MuiOutlinedInput-root': { padding: '4.5px 9px' },
                                                    '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                                                    '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
                                                }}
                                                {...params}
                                                label="Tax Type"
                                                InputLabelProps={{ ...params.InputLabelProps, shrink: (tax !== "" || (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0)) ? true : false }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xl={2} lg={4} sm={6} xs={12}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        sx={{
                                            marginTop: "-4px !important",
                                            "& .MuiAutocomplete-input": {
                                                padding: "0px 4px 0px 5px !important",
                                            },
                                        }}
                                        options={statusList}
                                        getOptionLabel={(option) => option}
                                        onChange={(event, value) => {
                                            setSelectedStatus(value ?? "");
                                            statusData.current = value ?? "";
                                        }}
                                        value={selectedStatus}
                                        renderInput={(params) => (
                                            <TextField
                                                sx={{
                                                    ".MuiFormLabel-root.Mui-focused": {
                                                        color: (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0) ? "#000" : "#cccccc !important",
                                                    },
                                                    '& .MuiInputBase-root': { marginTop: '5px !important' },
                                                    '& .MuiOutlinedInput-root': { padding: '4.5px 9px' },
                                                    '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                                                    '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
                                                }}
                                                {...params}
                                                label="Status"
                                                InputLabelProps={{ ...params.InputLabelProps, shrink: (selectedStatus !== "" || (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0)) ? true : false }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm="auto">
                                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                                    <Button
                                        variant="contained"
                                        size="medium"
                                        onClick={() => { fetchMainData(); }}
                                        startIcon={<Search />}
                                        sx={{
                                            textTransform: "none",
                                            fontWeight: 600,
                                            backgroundColor: "#2099d2",
                                            "&:hover": { backgroundColor: "#176990" },
                                        }}
                                    >
                                        Search
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        size="medium"
                                        onClick={() => { ClearSearch(); }}
                                        startIcon={<Close />}
                                        sx={{
                                            textTransform: "none",
                                            fontWeight: 600,
                                            borderColor: "#e2e8f0",
                                            color: "#475569",
                                            "&:hover": { borderColor: "#2099d2", color: "#2099d2" },
                                        }}
                                    >
                                        Clear
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        size="medium"
                                        onClick={() => window.location.reload()}
                                        startIcon={<Refresh />}
                                        sx={{
                                            textTransform: "none",
                                            fontWeight: 600,
                                            borderColor: "#e2e8f0",
                                            color: "#475569",
                                            "&:hover": {
                                                borderColor: "#2099d2",
                                                backgroundColor: "#2099d214",
                                                color: "#2099d2",
                                            },
                                        }}
                                    >
                                        Refresh
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                </Box>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", width: "100%", borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)', border: '1px solid #e2e8f0', backgroundColor: '#ffffff', position: 'relative' }}>
            {loading && (
                <Box
                    position="absolute"
                    top={0}
                    left={0}
                    right={0}
                    bottom={0}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    sx={{
                        backgroundColor: "rgba(250, 251, 252, 0.85)",
                        zIndex: 10,
                        border: "1px solid #e2e8f0",
                        borderRadius: 1,
                    }}
                >
                    <Box sx={{ width: "100%", maxWidth: 320 }}>
                        <LinearProgress color="info" sx={{ backgroundColor: "#e2e8f0", "& .MuiLinearProgress-bar": { backgroundColor: "#132D3D" } }} />
                        <Box sx={{ mt: 1.5, textAlign: "center" }}>
                            <span style={{ fontSize: "14px", fontWeight: 600, color: "#475569" }}>Loading...</span>
                        </Box>
                    </Box>
                </Box>
            )}
            <div className="d-flex align-items-center justify-content-between py-3 px-2">
                {selectedTab !== ReconTabs.Removed && <Typography variant="subtitle1" fontWeight={600} sx={{ color: '#334155', mr: 'auto', pl: 1 }}>Reconciliation Queue</Typography>}
                <div className="d-flex align-items-center gap-2">
                    {(user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("MISC State Reporter")) && (selectedRows !== null && selectedRows?.length > 0) ?
                        <Button
                            variant="contained"
                            size="small"
                            onClick={() => handleStatusChange()}
                            title="Paid"
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                backgroundColor: '#dc2626',
                                "&:hover": { backgroundColor: '#b91c1c' },
                            }}
                        >
                            {selectedTab === ReconTabs.Closed ? 'Revert' : 'Paid'}
                        </Button>
                        : ""
                    }
                    {selectedRows?.length !== 0 && selectedRows?.length !== undefined ?
                        <div className="dropdowm-class ms-2" style={{ zIndex: "9" }}>
                            <MenuDropdown
                                menuTitle={'Status'}
                                items={status as string[]}
                                onItemClick={handleStatus}
                                sx={{
                                    fontWeight: 600,
                                    backgroundColor: '#2099d2',
                                    '&:hover': { backgroundColor: '#176990' },
                                    px: 2,
                                }}
                            />
                        </div>
                        : ''}
                    <Button
                        variant="contained"
                        size="small"
                        onClick={() => { handleExportXlsxNew(); }}
                        startIcon={<FileDownload />}
                        sx={{ textTransform: "none", fontWeight: 600, backgroundColor: "#2099d2", "&:hover": { backgroundColor: "#176990" } }}
                    >
                        Export
                    </Button>
                </div>
            </div>

            {selectedTab === ReconTabs.Removed ? (
                <ReconciliationList
                    ReportModuleCL={reportModuleCL}
                    setSelectedRows={setSelectedRows}
                    selectedRows={selectedRows}
                    setCurrentPage={setCurrentPage}
                    setPageSize={setPageSize}
                    _pageSize={_pageSize}
                    filterModel={filterModel}
                    setFilterModel={setFilterModel}
                    setSortModel={setSortModel}
                    sortModel={sortModel}
                    loading={loading}
                />
                ) : (
                <>
                    {[ReconTabs.Open, ReconTabs.Closed].map((tab) => (
                        <TabPanel key={tab} value={selectedTab} index={tab}>
                            <ReconciliationList
                                ReportModuleCL={reportModuleCL}
                                setSelectedRows={setSelectedRows}
                                selectedRows={selectedRows}
                                setCurrentPage={setCurrentPage}
                                setPageSize={setPageSize}
                                _pageSize={_pageSize}
                                filterModel={filterModel}
                                setFilterModel={setFilterModel}
                                setSortModel={setSortModel}
                                sortModel={sortModel}
                                loading={loading}
                            />
                        </TabPanel>
                    ))}
                </>
                )}
            </Box>
            {openNotesDialog && (
                <FilerNotes
                    open={!!openNotesDialog}
                    handleClose={handleCloseNotesDialog}
                    handleSubmit={handleSubmitNotes}
                    selectedRows={selectedRows as unknown as NewCompletedFilingsModel[]}
                    currentStatus={openNotesDialog}
                    currentPolicySubStatus={currentPolicySubStatus}
                />
            )}
            <ShowPaymentPeriod handleClose={handleClosePaidDialog} open={openPaidDialog} />
        </LocalizationProvider>
    );
};
